import "./general.css";
import { useTranslation } from "react-i18next";
import { useState, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import SplitTextReveal from "./SplitTextReveal";

export default function AboveFooter() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const titleText = t("aboveFooter.title");
  // Pour mobile, on garde le texte tel quel, le CSS gérera les retours à la ligne si nécessaire
  const displayText = isMobile 
    ? titleText.replace(/\. /g, ".\n") 
    : titleText;

  const paragraphs = t("aboveFooter.text").split("\n\n");
  return (
    <div className="AboveFooter">
      <SplitTextReveal text={displayText} className="above-footer-title" />
      {paragraphs.map((para, i) => (
        <p
          key={i}
          // rend <u>…</u> et convertit \n => <br />
          dangerouslySetInnerHTML={{
            __html: para.replace(/\n/g, "<br />"),
          }}
        />
      ))}
      <Link to="/contact" className="websiteBtn thin">
        {t("aboveFooter.button")}
      </Link>
    </div>
  );
}
